import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();


export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? savedTheme : "system";
  });

  useEffect(() => {
    const root = window.document.documentElement;
    let appliedTheme = theme;
    if (theme === "system") {
      const isDark = window.matchMedia && window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      appliedTheme = isDark ? "dark" : "light";
    }
    root.setAttribute("data-theme", appliedTheme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Add toggleTheme function
  const toggleTheme = () => {
    if (theme === "light") setTheme("dark");
    else if (theme === "dark") setTheme("light");
    else setTheme("dark"); // If system, default to dark
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
